import React from 'react';
import 'react-toggle/style.css';
import { AppSumoBillingTable } from '../../components';

const AppSumoActiveScreen = () => {
  return (
    <div className="billing__plan-page">
      <AppSumoBillingTable />
    </div>
  );
};

export default AppSumoActiveScreen;
